import type { IShopInfoV7, TypeShop } from '@/app/types/editor/shop';
import type { TypePage } from '@/app/types/editor/page';
import type { FontMeta, ShopMeta, Meter } from './types';
import { defaultObGlobalStyle } from '@/modules/global-style';

/**
 * App State
 */
export class State {
  public shopInfo: TypeShop;
  public shopInfoV7?: IShopInfoV7;
  public pageInfo: TypePage;
  public isSaved: boolean;
  public isMakeDefault: boolean;
  public showGetSourceModal: boolean;
  public getSourceModalType: string;
  public disabledHistoryItem: boolean;
  public showPlanPopup: boolean;
  public showPageSettingModal: boolean;
  public shopMeta: ShopMeta;
  public fontMeta: FontMeta;
  public shopMeter: Meter;
  public navBarToast: object | null;
  public showOverlayApp: boolean;
  public enablePassword: boolean;
  public usedToDragDrop: boolean;
  public latestProductInShopifyStore: any;
  public planPermissions: any;
  public planLimitation: any;
  public screenOptions: Array<{ name: String; value: String; icon: String }> = [
    {
      name: 'Desktop',
      value: 'lg',
      icon: 'icon icon-desktop',
    },
    {
      name: 'Laptop',
      value: 'md',
      icon: 'icon icon-laptop',
    },
    {
      name: 'Tablet',
      value: 'sm',
      icon: 'icon icon-tablet',
    },
    {
      name: 'Mobile',
      value: 'xs',
      icon: 'icon icon-mobile',
    },
  ];
  public currentScreen: String = 'lg';

  constructor() {
    this.enablePassword = false;
    this.usedToDragDrop = false;
    this.showOverlayApp = false;
    this.shopInfo = null;
    this.shopInfoV7 = undefined;
    this.pageInfo = null;
    this.isSaved = false;
    this.isMakeDefault = false;
    this.showGetSourceModal = false;
    this.getSourceModalType = '';
    this.disabledHistoryItem = false;
    this.showPlanPopup = false;
    this.showPageSettingModal = false;
    this.planPermissions = {
      contentScheduling: false,
      lazyLoad: false,
      seasonalAndHolidayTemplate: false,
    };
    this.planLimitation = {};
    this.shopMeta = {
      firstCrawlPresetLiveTheme: false,
      onboardingGlobalStyle: defaultObGlobalStyle,
    };
    this.latestProductInShopifyStore = null;
    this.fontMeta = {
      activeFonts: null,
      themeFonts: null,
      installedFonts: null,
    };
    (this.shopMeter = {
      onboarding: false,
    }),
      (this.navBarToast = null);
  }
}

const state = new State();

export default state;
